<template>
   <UserRolePermissions></UserRolePermissions>
</template>
<script>
import UserRolePermissions from '@/components/DPEBB/Administrator/UserRolePermissions.vue';
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {

data: function () {
    return {
        AppServiceID :6,
         // menuitems:""
        }
    },
 components: {
    UserRolePermissions  : UserRolePermissions

        },
 created: function() {
    this.AppServiceID = this.$store.getters.GetDPEBBServiceID;
    this.$emit('update:layout', LayoutDefault);
},   
 beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDPEBBServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDPEBBServiceID);
    },
}
</script>
